(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-content"] && !Shopify.designMode) return;
  try {
    
  function initFaqPage(section) {
    var questions = section.querySelectorAll('.faq-page__question');

    questions.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answer = btn.parentElement.querySelector('.faq-page__answer');

        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          answer.classList.remove('faq-page__answer--open');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('faq-page__answer--open');
        }
      });
    });
  }

  document.querySelectorAll('.faq-page').forEach(initFaqPage);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target.querySelector('.faq-page');
      if (section) initFaqPage(section);
    });

    document.addEventListener('shopify:block:select', function(e) {
      var block = e.target;
      var answer = block.querySelector('.faq-page__answer');
      var btn = block.querySelector('.faq-page__question');
      if (answer && btn) {
        btn.setAttribute('aria-expanded', 'true');
        answer.classList.add('faq-page__answer--open');
      }
    });

    document.addEventListener('shopify:block:deselect', function(e) {
      var block = e.target;
      var answer = block.querySelector('.faq-page__answer');
      var btn = block.querySelector('.faq-page__question');
      if (answer && btn) {
        btn.setAttribute('aria-expanded', 'false');
        answer.classList.remove('faq-page__answer--open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"]) return;
  try {
    
(function() {
  var popup = document.querySelector('.promo-popup');
  if (!popup) return;

  var delay = parseInt(popup.dataset.delay || '2', 10) * 1000;
  var promoKey = 'promo_popup_' + (popup.dataset.promoKey || 'default');

  var backdrop = popup.querySelector('.promo-popup__backdrop');
  var closeBtn = popup.querySelector('.promo-popup__close');
  var form = popup.querySelector('.promo-popup__form');
  var reveal = popup.querySelector('.promo-popup__reveal');
  var revealClose = popup.querySelector('.promo-popup__reveal-close');
  var errorEl = popup.querySelector('.promo-popup__error');
  var emailInput = popup.querySelector('.promo-popup__email');

  /* Show popup with animation */
  function show() {
    popup.style.display = '';
    popup.classList.remove('promo-popup--closing');
    popup.setAttribute('aria-hidden', 'false');
    popup.offsetHeight;
    popup.classList.add('promo-popup--visible');
    document.body.style.overflow = 'hidden';
  }

  /* Dismiss popup — only hides for this session (will reappear next visit) */
  function dismiss() {
    popup.classList.remove('promo-popup--visible', 'promo-popup--code-only');
    popup.classList.add('promo-popup--closing');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    try {
      sessionStorage.setItem(promoKey + '_closed', '1');
    } catch (e) {}
    setTimeout(function() {
      popup.style.display = 'none';
    }, 400);
  }

  /* Mark as subscribed — permanently suppress popup */
  function markSubscribed() {
    try { localStorage.setItem(promoKey + '_subscribed', '1'); } catch (e) {}
  }

  /* Show code reveal overlay (inside full popup) */
  function showReveal() {
    reveal.setAttribute('aria-hidden', 'false');
    reveal.offsetHeight;
    reveal.classList.add('promo-popup__reveal--visible');
  }

  /* Show ONLY the code reveal (backdrop + code, no modal) */
  function showCodeOnly() {
    popup.style.display = '';
    popup.classList.remove('promo-popup--closing');
    popup.classList.add('promo-popup--code-only');
    popup.setAttribute('aria-hidden', 'false');
    reveal.setAttribute('aria-hidden', 'false');
    popup.offsetHeight;
    popup.classList.add('promo-popup--visible');
    reveal.classList.add('promo-popup__reveal--visible');
    document.body.style.overflow = 'hidden';
  }

  /* --- Close handlers (always attached) --- */
  backdrop.addEventListener('click', dismiss);
  closeBtn.addEventListener('click', dismiss);
  if (revealClose) {
    revealClose.addEventListener('click', dismiss);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('promo-popup--visible')) {
      dismiss();
    }
  });

  /* --- Popup form submit (Shopify's CAPTCHA hooks into the submit event) --- */
  if (form) {
    form.addEventListener('submit', function(e) {
      var email = (emailInput.value || '').trim();
      if (!email || !emailInput.validity.valid) {
        e.preventDefault();
        errorEl.textContent = 'Please enter a valid email address';
        errorEl.classList.add('promo-popup__error--visible');
        emailInput.focus();
        return;
      }

      errorEl.classList.remove('promo-popup__error--visible');

      /* Mark as subscribed (permanent) and store pending flag for code reveal */
      markSubscribed();
      try { sessionStorage.setItem(promoKey + '_pending', '1'); } catch (e2) {}

      /* Do NOT preventDefault — let Shopify process the form with CAPTCHA */
    });
  }

  /* --- Footer newsletter: let it submit natively, show code on return --- */
  var footerForm = document.getElementById('ContactFooter');
  if (footerForm) {
    footerForm.addEventListener('submit', function() {
      /* Mark as subscribed (permanent) and store pending flag for code reveal */
      markSubscribed();
      try { sessionStorage.setItem(promoKey + '_pending', '1'); } catch (e) {}
      /* Do NOT preventDefault — let the form submit natively with CAPTCHA */
    }, true);
  }

  /* --- Allow external triggers (e.g. announcement bar) --- */
  document.addEventListener('promo-popup:open', function() {
    show();
  });

  /* --- Check if we're returning from a successful newsletter submit --- */
  var hasPending = false;
  try { hasPending = !!sessionStorage.getItem(promoKey + '_pending'); } catch (e) {}
  if (hasPending) {
    try { sessionStorage.removeItem(promoKey + '_pending'); } catch (e) {}
    /* Show only the discount code overlay */
    showCodeOnly();
  }

  /* --- Auto-show popup (respects localStorage dismissal) --- */
  else if (window.Shopify && Shopify.designMode) {
    popup.classList.add('promo-popup--visible');
    popup.setAttribute('aria-hidden', 'false');
  } else {
    var subscribed = false;
    var closedThisSession = false;
    try { subscribed = !!localStorage.getItem(promoKey + '_subscribed'); } catch (e) {}
    try { closedThisSession = !!sessionStorage.getItem(promoKey + '_closed'); } catch (e) {}
    if (!subscribed && !closedThisSession) {
      setTimeout(show, delay);
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-return-page"] && !Shopify.designMode) return;
  try {
    
  function initPolicyPage(section) {
    var questions = section.querySelectorAll('.policy-page__question');

    questions.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answer = btn.parentElement.querySelector('.policy-page__answer');

        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          answer.classList.remove('policy-page__answer--open');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('policy-page__answer--open');
        }
      });
    });
  }

  document.querySelectorAll('.policy-page').forEach(initPolicyPage);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target.querySelector('.policy-page');
      if (section) initPolicyPage(section);
    });

    document.addEventListener('shopify:block:select', function(e) {
      var block = e.target;
      var answer = block.querySelector('.policy-page__answer');
      var btn = block.querySelector('.policy-page__question');
      if (answer && btn) {
        btn.setAttribute('aria-expanded', 'true');
        answer.classList.add('policy-page__answer--open');
      }
    });

    document.addEventListener('shopify:block:deselect', function(e) {
      var block = e.target;
      var answer = block.querySelector('.policy-page__answer');
      var btn = block.querySelector('.policy-page__question');
      if (answer && btn) {
        btn.setAttribute('aria-expanded', 'false');
        answer.classList.remove('policy-page__answer--open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-info"] && !Shopify.designMode) return;
  try {
    
  function initStoreInfo(section) {
    var navBtns = section.querySelectorAll('.store-info__nav-btn');
    var slides = section.querySelectorAll('.store-info__image-slide');

    if (!navBtns.length || !slides.length) return;

    navBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var index = btn.dataset.storeIndex;

        // Update active button
        navBtns.forEach(function(b) {
          b.classList.remove('store-info__nav-btn--active');
        });
        btn.classList.add('store-info__nav-btn--active');

        // Switch image
        slides.forEach(function(s) {
          s.classList.toggle('store-info__image-slide--active', s.dataset.storeIndex === index);
        });
      });
    });
  }

  document.querySelectorAll('.store-info').forEach(initStoreInfo);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target.querySelector('.store-info');
      if (section) initStoreInfo(section);
    });

    document.addEventListener('shopify:block:select', function(e) {
      var block = e.target;
      var section = block.closest('.store-info');
      if (!section) return;

      var index = Array.from(section.querySelectorAll('.store-info__store')).indexOf(block);
      if (index < 0) return;

      var navBtns = section.querySelectorAll('.store-info__nav-btn');
      var slides = section.querySelectorAll('.store-info__image-slide');

      navBtns.forEach(function(b, i) {
        b.classList.toggle('store-info__nav-btn--active', i === index);
      });
      slides.forEach(function(s) {
        s.classList.toggle('store-info__image-slide--active', parseInt(s.dataset.storeIndex) === index);
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
